import TestimonialCarousel from "./TestimonialCarousel"
import { parentTestimonials } from "../../constants"

const ParentTestimonialCarousel = () => {
  return <TestimonialCarousel testimonials={parentTestimonials} />
}

export default ParentTestimonialCarousel
